import { ConversationsGroupProps } from './conversation-groups';
import ConversationGroupSkeleton from './conversation-group-skeleton/conversation-group-skeleton.component';
import ConversationGroup from './conversation-group/conversation-group.component';

const ConversationGroups = ({
  isLoading, conversationGroups,
}: ConversationsGroupProps): JSX.Element => {
  if (isLoading) {
    return <ConversationGroupSkeleton />;
  }

  return <ConversationGroup conversationGroups={ conversationGroups } />;
};

export default ConversationGroups;
